import Vue from 'vue';
import Tooltip from 'src/components/Tooltips/Tooltip.vue';
export default Vue.extend({
    name: 'RefreshButton',
    components: { Tooltip },
});
